import React from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as AlertIcon } from "svg/alert.svg";

const NoData = () => {
  const { pathname } = useLocation();
  const isEchoPage = pathname.includes("echo");
  const isRosterPage = pathname.split("/").length === 3;
  let noDataText = "No data for current filters. Refresh the page or broaden your search.";

  if (isEchoPage) {
    noDataText = isRosterPage
      ? "We don't have data yet for this boss. Please check back later."
      : "Either we don't have data yet for this boss or this player did not participate in this fight. Please check back later.";
  }

  return (
    <div className="no-data-container">
      <div className="alert">
        <AlertIcon />
      </div>
      <div className="text-container">
        <div>{noDataText}</div>
      </div>
    </div>
  );
};

export default NoData;
